import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aaos-app-resident-curriculum-page',
  templateUrl: './resident-curriculum-page.component.html',
  styleUrls: ['./resident-curriculum-page.component.scss']
})
export class ResidentCurriculumPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
